<template lang="pug">
f-grid(title="富文本维护", ref="grid", :columns="columns", :data="getList")
  template(#contentKey="{ row }")
    el-link(type="primary" @click="showDialog(2, row)")
      span(class="tabLinkSpan" :title='row.contentKey') {{ row.contentKey }}
  template(#tools="{ row }")
    el-button(type="text", icon="el-icon-edit", @click="showDialog(2, row)")
    el-button(type="text", icon="el-icon-delete", @click="deleteRow(row)")
  template(#header)
    el-button(icon="el-icon-plus", type="primary", @click="showDialog(0)" size='small') 新增
    el-dialog(width="860px", title="富文本", v-dialog-drag, :visible.sync="visible", @closed="close", :close-on-click-modal="false")
      el-form(size="small", label-width="70px", :disabled="isRead", ref="form", :rules="rules")
        el-form-item(label="标题")
          el-input(v-model="form.title", :maxLength="50")
        el-form-item(label="关联名称")
          el-input(v-model="form.contentKey", :disabled="!isCreate", :maxLength="50")
        el-form-item(label="内容")
          quill-editor.f-editor(v-model="form.content", :options="editorOption")
      template(#footer)
        el-button(@click="close" size='small') 取消
        el-button(type="primary", @click="submit" size='small') 确定
</template>
<script>
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { pub_rich_content_delete, pub_rich_content_details, pub_rich_content_list, pub_rich_content_save, pub_rich_content_update } from "@/CommonDP/service/rich-text-service.js";
const newForm = (d) => ({ title: "", content: "", ...d });
export default {
  name: "RichTextStore",
  components: { quillEditor, FGrid: () => import("@/CommonDP/components/FGrid") },
  data() {
    return {
      visible: false,
      editState: 0,
      editorOption: {
        placeholder: "请输入",
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
            ["link", "image"] // 去除video即可
          ]
        }
      },
      rules: {
        content: { required: true, message: "请输入内容" },
        contentKey: { required: true, message: "请输入关联名称" },
        title: { required: true, message: "请输入标题" }
      },
      form: newForm(),
      columns: [
        { type: "index", label: "序号", width: 60, align: "center" },
        { prop: "contentKey", label: "关联名称", width: 150, align: "center" },
        { prop: "title", label: "标题", showOverflowTooltip: true },
        { prop: "createUserName", label: "创建人", width: 150 },
        { prop: "createTime", label: "修改时间", width: 150 },
        { prop: "tools", label: "操作", width: 100 }
      ]
    };
  },
  computed: {
    isCreate() {
      return this.editState === 0;
    },
    isRead() {
      return this.editState === 1;
    },
    isEdit() {
      return this.editState === 2;
    }
  },
  methods: {
    async showDialog(editState, row) {
      let data = {};
      if (row) {
        const res = await pub_rich_content_details({ contentKey: row.contentKey });
        data = res.data;
      }
      this.editState = editState;
      this.form = newForm(data);
      this.visible = true;
    },
    async deleteRow({ contentKey }) {
      await this.$confirm("警告", "确定删除");
      await pub_rich_content_delete({ contentKey });
      this.$message.success("删除成功");
      this.$refs.grid.search();
    },
    async addData() {
      this.editState = 0;
      this.visible = true;
    },
    getList(page) {
      const res = pub_rich_content_list({ ...page });
      return res;
    },
    close() {
      this.form = newForm();
      this.$refs.form.clearValidate();
      this.visible = false;
    },
    async submit() {
      await this.$refs.form.validate();
      const { form, editState } = this;
      const update = editState === 0 ? pub_rich_content_save : pub_rich_content_update;
      await update(form);
      this.$message.success("保存成功");
      this.close();
      this.$refs.grid.search(1);
    }
  }
};
</script>
<style lang="scss" scoped>
.f-grid {
  height: 100%;
}
.f-editor /deep/ .ql-editor {
  height: 250px;
}
</style>
